module.exports = __webpack_public_path__ + "img/wx-acode.942d97ea.png";